import { useState } from 'react';
import { captureFunnelEvent, trackButtonClick } from '../services/telemetry';

const WAITLIST_URL =
  'https://docs.google.com/forms/d/1bPtMAxkcg0tH2qHk0GM4ujCwxxRe6vnP1excITw9lfE';

interface MobileAppWaitlistBannerProps {
  source: string;
}

function MobileAppWaitlistBanner({ source }: MobileAppWaitlistBannerProps) {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) {
    return null;
  }

  return (
    <div
      className={`
        relative w-full border-b border-gray-300 bg-yellow-100 px-4 py-2
        font-[Outfit]
      `}
      role="region"
      aria-label="iOS app coming soon"
    >
      <div
        className={`
          mx-auto flex max-w-6xl items-center justify-center gap-3 pr-8
          text-center
          sm:gap-4 sm:pr-10
        `}
      >
        {/* Deliberately does not describe scan-to-fingering: the home hero
            already offers that in-browser, and framing it as "coming soon"
            reads as if the page's own camera flow isn't available yet. */}
        <p className="text-sm font-semibold text-gray-800">
          iOS app is coming soon
        </p>
        <a
          href={WAITLIST_URL}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => {
            captureFunnelEvent('mobile_app_waitlist_clicked', { source });
            trackButtonClick(source, 'Mobile App Waitlist');
          }}
          className={`
            inline-block rounded-full border border-gray-800 bg-transparent px-4
            py-1.5 text-sm font-semibold text-gray-800 transition-transform
            duration-100
            hover:bg-gray-800/5
            active:scale-95
          `}
        >
          Join the waitlist
        </a>
      </div>
      <button
        type="button"
        onClick={() => setIsVisible(false)}
        aria-label="Dismiss announcement"
        className={`
          absolute top-1/2 right-3 flex h-10 w-10 -translate-y-1/2
          cursor-pointer items-center justify-center rounded-full text-2xl
          leading-none text-gray-500
          hover:bg-gray-100 hover:text-gray-800
        `}
      >
        ×
      </button>
    </div>
  );
}

export { MobileAppWaitlistBanner };
